import React, { useState } from 'react'
import { IconButton, TextField, Tooltip } from '@mui/material'
import { IconCheck, IconX } from '@tabler/icons-react'

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const PHONE_REGEX = /^\+?[\d\s\-()]{6,20}$/

interface Iprops {
  setContact: (e: string) => void
  type?: 'email' | 'phone'
  setItemClicked: (e: boolean) => void
  handleApprove: () => void
}

const CreateContactRow: React.FC<Iprops> = ({
  setContact,
  type = 'email',
  setItemClicked,
  handleApprove,
}) => {
  const [value, setValue] = useState('')
  const [error, setError] = useState('')

  const validate = (val: string): boolean => {
    if (!val.trim()) {
      setError(type === 'email' ? 'Email is required' : 'Phone number is required')
      return false
    }
    if (type === 'email' && !EMAIL_REGEX.test(val)) {
      setError('Invalid email format')
      return false
    }
    if (type === 'phone' && !PHONE_REGEX.test(val)) {
      setError('Invalid phone number')
      return false
    }
    setError('')
    return true
  }

  const submit = () => {
    if (!validate(value)) return
    handleApprove()
    setItemClicked(false)
  }

  return (
    <div className="CreateContactRow">
      <TextField
        className="textField"
        margin="none"
        sx={{ marginBottom: 0 }}
        fullWidth
        id="contact"
        name="contact"
        type={type}
        onChange={(e) => {
          const val = e.currentTarget.value
          setValue(val)
          setContact(val)
          if (error) validate(val)
        }}
        onKeyDown={(e) => e.key === 'Enter' && submit()}
        autoFocus
        error={!!error}
        helperText={error}
      />
      <div className="decide">
        <div className="iconsCont">
          <Tooltip title="Cancel" onClick={() => setItemClicked(false)}>
            <IconButton>
              <IconX className="icon" />
            </IconButton>
          </Tooltip>
          <div></div>
          <Tooltip title="Approve" onClick={submit}>
            <IconButton>
              <IconCheck className="icon" />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}

export default CreateContactRow
